export const SET_MIGRATION_DIALOG = "SET_MIGRATION_DIALOG";


export function setMigrationDialog(isOpen: boolean) {
    return {
        type: SET_MIGRATION_DIALOG,
        payload: isOpen
    }
}